// Audit fix 14: run scroll work at most once per frame instead of on every
// scroll event (noticeable jank on low-end phones otherwise).
function cgRafThrottle(fn) {
  var scheduled = false;
  return function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      fn();
    });
  };
}

jQuery(window).scroll(cgRafThrottle(function(){
  var sticky = jQuery('.site-header'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
}));

/* Custom Theme JavaScript */
;(function($, window, document) {
  'use strict';

  function initNavToggle() {
    $('.nav-button').on('click', function() {
      $('.site-menu').toggleClass('open');
      $(this).toggleClass('active');
      // Audit fix 12: lock the page behind the open drawer
      $('body').css('overflow', $('.site-menu').hasClass('open') ? 'hidden' : '');
    });
  }

  function initSearchPlaceholder() {
    var $input = $('#wk-search-input');
    if (!$input.length) return;

    var placeholders = [
      'Search products…',
      'Search categories…',
      'Search brands…'
    ];
    var textIndex = 0, charIndex = 0;
    var typingSpeed = 100;   // ms per character
    var pauseBetween = 1500; // pause after a word

    function typeEffect() {
      if (charIndex < placeholders[textIndex].length) {
        $input.attr('placeholder', placeholders[textIndex].substring(0, charIndex + 1));
        charIndex++;
        setTimeout(typeEffect, typingSpeed);
      } else {
        setTimeout(function() {
          charIndex = 0;
          textIndex = (textIndex + 1) % placeholders.length;
          $input.attr('placeholder', '');
          typeEffect();
        }, pauseBetween);
      }
    }

    typeEffect();
  }

  function initTheme() {
    initNavToggle();
    initSearchPlaceholder();
    if (typeof initSlickSlider === 'function') initSlickSlider();
    if (typeof initProductSpotlight === 'function') initProductSpotlight();
    if (typeof initProductVariants === 'function') initProductVariants();
    if (typeof initUIBindings === 'function') initUIBindings();
    // Initialize color swatches globally so server-rendered cards (e.g., search) pick up styles and interactions
    if (window.ColorSwatches && typeof window.ColorSwatches.init === 'function') {
      window.ColorSwatches.init(document);
    }
    if (window.recentlyViewed && typeof window.recentlyViewed.trackProduct === 'function') {
      window.recentlyViewed.trackProduct();
    }
    if (typeof initBackToTop === 'function') initBackToTop();
  }

  $(initTheme);
})(jQuery, window, document);
// Slick Slider Initialization
function initSlickSlider() {
  var $ = jQuery;
  if (typeof $ === 'undefined' || typeof $.fn.slick === 'undefined') return;

  function updateTimelineRunner() {
    var $timeline = $('.timeline');
    var $runner = $('.timeline .runner');

    if ($timeline.length && $runner.length) {
      var timelineTop = $timeline.offset().top;
      var timelineHeight = $timeline.outerHeight();
      var timelineBottom = timelineTop + timelineHeight;
      var scrollTop = $(window).scrollTop();
      var windowHeight = $(window).height();

      // Check if timeline is in viewport
      if (scrollTop + windowHeight > timelineTop && scrollTop < timelineBottom) {
        // Calculate progress based on middle of screen
        var middleOfScreen = scrollTop + (windowHeight / 2);
        var sectionStart = Math.max(0, middleOfScreen - timelineTop);
        var sectionProgress = Math.min(sectionStart / timelineHeight, 1);

        // Update runner height based on progress
        var runnerHeight = sectionProgress * 100;
        $runner.css('height', runnerHeight + '%');
      }
    }
  }
  // Update on scroll (audit fix 14: frame-throttled — this handler forces
  // layout reads and previously ran on every scroll tick)
  $(window).on('scroll', cgRafThrottle(updateTimelineRunner));
  // Update on load
  updateTimelineRunner();
}

// Global Color Swatches module
window.ColorSwatches = (function() {
  function hexToRgb(hex) {
    const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
    return m ? `rgb(${parseInt(m[1],16)}, ${parseInt(m[2],16)}, ${parseInt(m[3],16)})` : 'rgb(204, 204, 204)';
  }
  function resolveColorName(name) {
    const n = (name || '').toLowerCase().trim();
    if (!n) return 'rgb(204, 204, 204)';

    // Curated mappings for non-standard names commonly used in catalogs
    const namedMap = {
      'bronze': 'rgb(205, 127, 50)',         // #cd7f32
      'rose gold': 'rgb(183, 110, 121)',     // approx
      'rosegold': 'rgb(183, 110, 121)',
      'champagne': 'rgb(247, 231, 206)',
      'silver': 'rgb(192, 192, 192)',
      'gold': 'rgb(255, 215, 0)',
      'charcoal': 'rgb(54, 69, 79)',
      'navy': 'rgb(0, 0, 128)',
      'sky blue': 'rgb(135, 206, 235)',
      'sky': 'rgb(135, 206, 235)',
      'teal': 'rgb(0, 128, 128)',
      'mustard': 'rgb(255, 219, 88)',
      'beige': 'rgb(245, 245, 220)'
    };

    // Substring-based mapping for variations, e.g., "antique bronze"
    if (n.includes('bronze')) return namedMap['bronze'];
    if (namedMap[n]) return namedMap[n];

    // Try browser resolution only if the style property accepts the value
    const probe = document.createElement('span');
    probe.style.color = n;
    const isValid = probe.style.color !== '';
    if (isValid) {
      document.body.appendChild(probe);
      const resolved = window.getComputedStyle(probe).color;
      document.body.removeChild(probe);
      if (resolved && resolved.startsWith('rgb')) return resolved;
    }

    if (n === 'white') return 'rgb(255, 255, 255)';
    if (n === 'black') return 'rgb(0, 0, 0)';
    return 'rgb(204, 204, 204)';
  }
  function resolveValue(val) {
    const v = (val || '').trim();
    if (!v) return 'rgb(204, 204, 204)';
    if (v.startsWith('#')) return hexToRgb(v);
    if (v.startsWith('rgb')) return v;
    return resolveColorName(v);
  }
  function isNearWhite(rgbString) {
    const match = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(rgbString || '');
    if (!match) return false;
    const r = parseInt(match[1], 10);
    const g = parseInt(match[2], 10);
    const b = parseInt(match[3], 10);
    // Treat anything very light (not just pure white) as needing a border,
    // so it doesn't disappear against a white page background.
    return r >= 240 && g >= 240 && b >= 240;
  }
  function applyBackgroundAndBorder(el, value, imageUrl) {
    if (imageUrl) {
      el.style.backgroundImage = `url('${imageUrl}')`;
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center';
      el.style.backgroundColor = '';
      el.style.border = '1px solid #e0e0e0';
      return;
    }
    el.style.backgroundImage = '';
    const rgb = resolveValue(value);
    el.style.backgroundColor = rgb;
    if (isNearWhite(rgb)) {
      el.style.border = '2px solid #000';
    } else {
      el.style.border = '2px solid transparent';
    }
  }

  function formatCentsUsingCurrentSymbol(cents, fallbackSymbol) {
    const symbol = fallbackSymbol
      || (window.__CURRENCY__ && window.__CURRENCY__.symbol)
      || (document.querySelector('[data-price-display]')?.textContent?.match(/^[^0-9£$€¥]+|^[£$€¥]/)?.[0])
      || '£';
    const amount = (parseInt(cents, 10) || 0) / 100;
    return `${symbol}${amount.toFixed(2)}`;
  }

  function bindSwatchClicks(card) {
    const colorSwatches = card.querySelectorAll('.color-swatch');
    const variantInput = card.querySelector('[data-variant-input]');
    // Must be img-specific: compare buttons also carry a data-product-image
    // attribute and can appear earlier in the card DOM
    const productImage = card.querySelector('img[data-product-image]');

    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        colorSwatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');

        const variantId = this.dataset.variantId;
        const variantPrice = this.dataset.variantPrice;
        const comparePrice = this.dataset.variantComparePrice;
        const available = this.dataset.variantAvailable === 'true';
        const image = this.dataset.variantImage;

        if (variantInput && variantId) variantInput.value = variantId;

        const priceDisplay = card.querySelector('[data-price-display]');
        if (priceDisplay && variantPrice) {
          const trimmed = String(variantPrice).trim();
          priceDisplay.textContent = /^\d+$/.test(trimmed)
            ? formatCentsUsingCurrentSymbol(trimmed)
            : trimmed;
        }

        const originalPrice = card.querySelector('.price-original');
        if (originalPrice) {
          const trimmedCompare = String(comparePrice || '').trim();
          const trimmedPrice = String(variantPrice || '').trim();
          const showCompare = trimmedCompare && trimmedCompare !== trimmedPrice;
          if (showCompare) {
            originalPrice.textContent = /^\d+$/.test(trimmedCompare)
              ? formatCentsUsingCurrentSymbol(trimmedCompare)
              : trimmedCompare;
            originalPrice.style.display = '';
          } else {
            originalPrice.style.display = 'none';
          }
        }

        const stockDisplay = card.querySelector('[data-stock-display]');
        if (stockDisplay) {
          const span = stockDisplay.querySelector('span') || document.createElement('span');
          span.className = available ? 'in-stock' : 'out-of-stock';
          span.textContent = available ? 'In Stock' : 'Out of Stock';
          if (!span.parentElement) stockDisplay.appendChild(span);
        }

        const addToCartBtn = card.querySelector('[data-add-to-cart]');
        if (addToCartBtn) {
          if (available) {
            addToCartBtn.classList.remove('disabled');
            addToCartBtn.removeAttribute('disabled');
          } else {
            addToCartBtn.classList.add('disabled');
            addToCartBtn.setAttribute('disabled', 'disabled');
          }
        }

        if (productImage && image) {
          productImage.style.transition = 'opacity 0.3s ease';
          productImage.style.opacity = '0.6';
          const img = new Image();
          img.onload = function() {
            productImage.src = image;
            productImage.style.opacity = '1';
          };
          img.onerror = function() {
            productImage.style.opacity = '1';
          };
          img.src = image;
        }
      });
    });
  }

  function init(scope) {
    const root = scope || document;

    // Apply backgrounds for swatch filters
    root.querySelectorAll('.color-swatch-filter').forEach(el => {
      const imageUrl = el.dataset.swatchImage || '';
      const name = el.dataset.colorName || el.getAttribute('title') || '';
      applyBackgroundAndBorder(el, name, imageUrl);
    });

    // Apply backgrounds for swatch buttons
    root.querySelectorAll('.color-swatch').forEach(btn => {
      const imageUrl = btn.dataset.swatchImage || '';
      const value = btn.dataset.metafieldColor || btn.dataset.colorName || btn.getAttribute('title') || '';
      applyBackgroundAndBorder(btn, value, imageUrl);
    });

    // Apply backgrounds for the static swatch legend (product page colour-to-name key)
    root.querySelectorAll('.swatch-legend-dot').forEach(dot => {
      const imageUrl = dot.dataset.swatchImage || '';
      const value = dot.dataset.metafieldColor || dot.dataset.colorName || dot.getAttribute('title') || '';
      applyBackgroundAndBorder(dot, value, imageUrl);
    });

    // Bind clicks per product card
    root.querySelectorAll('.product-card, .pbox').forEach(bindSwatchClicks);

    // Initialize slick for color-navigation groups
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      root.querySelectorAll('.color-navigation').forEach(nav => {
        // Pages can opt out of the carousel (e.g. search results wrap
        // their swatches in a flex row instead)
        if (nav.classList.contains('no-slider')) return;
        if (nav.classList.contains('slick-initialized')) {
          jQuery(nav).slick('unslick');
        }
        const swatchCount = nav.querySelectorAll('.scolor-box').length;
        if (swatchCount > 4) {
          jQuery(nav).slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev">‹</button>',
            nextArrow: '<button type="button" class="slick-next">›</button>',
            responsive: [{ breakpoint: 480, settings: { slidesToShow: 4 } }]
          });
        }
      });
    }
  }

  return { init, resolveColorName, hexToRgb };
})();

// Product Spotlight Variant Selection
function initProductSpotlight() {
  const section = document.querySelector('.product-spotlight');
  if (!section) return;
  if (window.ColorSwatches) window.ColorSwatches.init(section);
}

// Initialization is handled by the unified jQuery ready handler above to avoid duplicate runs.

// Recently Viewed Products Functionality
function initRecentlyViewed() {
  'use strict';

  // Configuration
  const STORAGE_KEY = 'recently_viewed_products';
  const SWATCH_CACHE_KEY = 'recently_viewed_swatch_data';
  const MAX_PRODUCTS = 8;

  // Get products from localStorage with validation
  function getProducts() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      const products = stored ? JSON.parse(stored) : [];
      const validProducts = products.filter(item =>
        typeof item === 'string' && !/^\d+$/.test(item) && item.length > 0
      );

      if (validProducts.length !== products.length) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(validProducts));
      }

      return validProducts;
    } catch (e) {
      return [];
    }
  }

  // Real swatch colour/image data can only be read from Liquid (product.js
  // has no swatch info), so we capture it straight off the DOM whenever the
  // person is actually on a product page, keyed by handle.
  function getSwatchCache() {
    try {
      const stored = localStorage.getItem(SWATCH_CACHE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }

  function cacheSwatchDataForCurrentProduct(handle) {
    if (!handle) return;
    const swatchButtons = document.querySelectorAll('.pinfo .swatch-group .color-swatch');
    if (!swatchButtons.length) return;

    const map = {};
    swatchButtons.forEach(function (btn) {
      const value = btn.dataset.value;
      if (!value) return;
      map[value] = {
        color: btn.dataset.metafieldColor || null,
        image: btn.dataset.swatchImage || null
      };
    });

    try {
      const cache = getSwatchCache();
      cache[handle] = map;
      // Keep the cache from growing forever alongside the 8-product cap
      const keep = getProducts().concat([handle]);
      Object.keys(cache).forEach(function (key) {
        if (keep.indexOf(key) === -1) delete cache[key];
      });
      localStorage.setItem(SWATCH_CACHE_KEY, JSON.stringify(cache));
    } catch (e) {}
  }

  // Add product to recently viewed
  function addProduct(handle) {
    if (!handle) return;

    let recentProducts = getProducts().filter(x => x !== handle);
    recentProducts.unshift(handle);

    if (recentProducts.length > MAX_PRODUCTS) {
      recentProducts = recentProducts.slice(0, MAX_PRODUCTS);
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentProducts));
    } catch (e) {}
  }

  // Format price for display using the active currency symbol
  function formatPrice(price) {
    const symbol = (window.__CURRENCY__ && window.__CURRENCY__.symbol) || '£';
    return price ? `${symbol}${(price / 100).toFixed(2)}` : `${symbol}0.00`;
  }

  // Create product card element
  function createCard(product, sectionId) {
    const cardElement = document.createElement('div');
    cardElement.className = 'product-card';
    cardElement.setAttribute('data-product-id', product.id);

    const variant = product.variants?.[0] || {
      id: 'default',
      price: product.price || 0,
      compare_at_price: product.compare_at_price,
      available: true,
      featured_image: product.featured_image
    };

    // Find color option index
    function findColorIndex() {
      const checkOptions = options => {
        for (let i = 0; i < options.length; i++) {
          const name = typeof options[i] === 'string' ? options[i] : options[i]?.name || options[i];
          if (name?.toLowerCase().includes('color')) return i + 1;
        }
        return 0;
      };

      return checkOptions(product.options || []) ||
             checkOptions(product.option_names || []) ||
             detectColorOption();
    }

    // Detect color option by analyzing variants
    function detectColorOption() {
      if (!product.variants || product.variants.length <= 1) return 0;

      const colorKeywords = ['red', 'blue', 'green', 'black', 'white', 'yellow',
                            'pink', 'purple', 'orange', 'brown', 'gray', 'grey'];
      const optionSets = [new Set(), new Set(), new Set()];

      product.variants.forEach(variant => {
        if (variant.option1) optionSets[0].add(variant.option1);
        if (variant.option2) optionSets[1].add(variant.option2);
        if (variant.option3) optionSets[2].add(variant.option3);
      });

      for (let i = 0; i < optionSets.length; i++) {
        if (optionSets[i].size > 1 &&
            Array.from(optionSets[i]).some(val =>
              colorKeywords.some(color => val.toLowerCase().includes(color))
            )) {
          return i + 1;
        }
      }

      return 0;
    }

    const colorIndex = findColorIndex();

    // Generate color swatches
    function generateSwatches() {
      if (!colorIndex || !product.variants?.length) return '<div class="color-navigation color-navigation--placeholder" style="min-height: 24px;" aria-hidden="true"></div>';

      const processedColors = new Set();
      let swatchesHTML = '<div class="color-navigation">';

      product.variants.forEach(variantItem => {
        const colorValue = variantItem[`option${colorIndex}`];
        if (!colorValue || processedColors.has(colorValue)) return;

        processedColors.add(colorValue);
        const activeClass = variantItem.id === variant.id ? 'active' : '';
        const cachedSwatch = (getSwatchCache()[product.handle] || {})[colorValue] || null;

        // Get variant image
        let variantImageSrc = '';
        if (variantItem.featured_image) {
          variantImageSrc = typeof variantItem.featured_image === 'string' ?
                           variantItem.featured_image : variantItem.featured_image.src;
        } else if (product.featured_image) {
          variantImageSrc = typeof product.featured_image === 'string' ?
                           product.featured_image : product.featured_image.src;
        }

        // Format image URL
        if (variantImageSrc && typeof variantImageSrc === 'string') {
          if (!variantImageSrc.includes('_400x400') && !variantImageSrc.includes('?')) {
            variantImageSrc = variantImageSrc.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '_400x400.$1');
          }
          if (!variantImageSrc.startsWith('http')) {
            variantImageSrc = variantImageSrc.startsWith('//') ?
                             'https:' + variantImageSrc :
                             'https://' + variantImageSrc.replace(/^\//,'');
          }
        }

        swatchesHTML += `<div class="scolor-box">
          <button type="button" class="color-swatch ${activeClass}"
                  data-variant-id="${variantItem.id}"
                  data-variant-price="${formatPrice(variantItem.price)}"
                  data-variant-compare-price="${variantItem.compare_at_price ? formatPrice(variantItem.compare_at_price) : ''}"
                  data-variant-available="${variantItem.available}"
                  data-variant-image="${variantImageSrc}"
                  data-color-name="${colorValue}"
                  ${cachedSwatch && cachedSwatch.image ? `data-swatch-image="${cachedSwatch.image}"` : ''}
                  ${cachedSwatch && !cachedSwatch.image && cachedSwatch.color ? `data-metafield-color="${cachedSwatch.color}"` : ''}
                  title="${colorValue}">
            <span class="sr-only">${colorValue}</span>
          </button>
        </div>`;
      });

      return swatchesHTML + '</div>';
    }

    const swatchesHTML = generateSwatches();

    // Get main product image
    let mainImageSrc = '';
    if (variant.featured_image) {
      mainImageSrc = typeof variant.featured_image === 'string' ?
                    variant.featured_image : variant.featured_image.src;
    } else if (product.featured_image) {
      mainImageSrc = typeof product.featured_image === 'string' ?
                    product.featured_image : product.featured_image.src;
    } else if (product.images && product.images.length > 0) {
      mainImageSrc = typeof product.images[0] === 'string' ?
                    product.images[0] : product.images[0].src;
    }

    // Format main image URL
    if (mainImageSrc && typeof mainImageSrc === 'string') {
      if (!mainImageSrc.includes('_400x400') && !mainImageSrc.includes('?')) {
        mainImageSrc = mainImageSrc.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '_400x400.$1');
      }
      if (!mainImageSrc.startsWith('http')) {
        mainImageSrc = mainImageSrc.startsWith('//') ?
                      'https:' + mainImageSrc :
                      'https://' + mainImageSrc.replace(/^\//,'');
      }
    }

    // Build card HTML
    cardElement.innerHTML = `
      <div class="product-card-wrap">
        <div class="product-image-wrapper">
          ${mainImageSrc ?
            `<img src="${mainImageSrc}" alt="${product.title}" class="product-image" data-product-image loading="lazy">` :
            `<div class="product-image-placeholder"><span>No Image</span></div>`
          }
        </div>
        <div class="pro-content">
          ${swatchesHTML}
          <h3 class="product-title">
            <a href="/products/${product.handle}">${product.title}</a>
          </h3>
          <div class="product-pricing">
            From <span class="price-current" data-price-display>${formatPrice(variant.price)}</span>
            ${variant.compare_at_price > variant.price ?
              `<span class="price-original">${formatPrice(variant.compare_at_price)}</span>` : ''
            }
          </div>
          <div class="stock-status" data-stock-display>
            <span class="${variant.available ? 'in-stock' : 'out-of-stock'}">
              ${variant.available ? 'In Stock' : 'Out of Stock'}
            </span>
          </div>
          <a href="/products/${product.handle}" class="common-btn">View More</a>
        </div>
      </div>`;

    // Apply color backgrounds for newly generated swatches
    if (window.ColorSwatches) {
      window.ColorSwatches.init(cardElement);
    }

    return cardElement;
  }

  // Load products from localStorage and fetch their data
  function loadProducts(sectionId) {
    const handles = getProducts();
    const section = document.getElementById(`recently-viewed-${sectionId}`);
    const container = document.getElementById('recently-viewed-products');

    if (handles.length === 0) {
      if (container) {
        container.innerHTML = '<p style="text-align: center; padding: 20px; color: #666;">No Recently viewed items yet. Visit some product pages to see them here!</p>';
      }
      return;
    }

    if (section) section.style.display = 'block';

    // Fetch product data for all handles
    Promise.all(
      handles.slice(0, MAX_PRODUCTS).map(handle =>
        fetch(`/products/${handle}.js`)
          .then(response => response.ok ? response.json() : null)
          .catch(() => null)
      )
    ).then(products => {
      const validProducts = products.filter(Boolean);
      if (validProducts.length > 0) {
        renderProducts(validProducts, sectionId);
      } else if (section) {
        section.style.display = 'none';
      }
    });
  }

  // Render products in the container
  function renderProducts(products, sectionId) {
    const container = document.getElementById('recently-viewed-products');
    if (!container) return;

    container.innerHTML = '';
    const productsToShow = products.slice(0, MAX_PRODUCTS);

    if (productsToShow.length === 0) {
      const section = document.getElementById(`recently-viewed-${sectionId}`);
      if (section) section.style.display = 'none';
      return;
    }

    productsToShow.forEach(product => container.appendChild(createCard(product, sectionId)));

    // Initialize interactive features
    initializeRecentlyViewedSwatches(sectionId);
    initializeRecentlyViewedSlider();
    initializeRecentlyViewedColorSliders(sectionId);
  }

  // Initialize color swatch functionality for recently viewed
  function initializeRecentlyViewedSwatches(sectionId) {
    document.querySelectorAll(`#recently-viewed-${sectionId} .product-card`).forEach(card => {
      const swatches = card.querySelectorAll('.color-swatch');
      const elements = {
        variantInput: card.querySelector('[data-variant-input]'),
        priceDisplay: card.querySelector('[data-price-display]'),
        stockDisplay: card.querySelector('[data-stock-display]'),
        addToCart: card.querySelector('[data-add-to-cart]'),
        productImage: card.querySelector('img[data-product-image]')
      };

      swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          // Remove active class from all swatches
          swatches.forEach(s => s.classList.remove('active'));
          this.classList.add('active');

          const { variantId, variantPrice, variantAvailable, variantImage } = this.dataset;
          const isAvailable = variantAvailable === 'true';

          // Update variant input
          if (elements.variantInput) elements.variantInput.value = variantId;

          // Update price display
          if (elements.priceDisplay) elements.priceDisplay.textContent = variantPrice;

          // Update stock display
          if (elements.stockDisplay) {
            const stockSpan = elements.stockDisplay.querySelector('span');
            if (stockSpan) {
              stockSpan.className = isAvailable ? 'in-stock' : 'out-of-stock';
              stockSpan.textContent = isAvailable ? 'In Stock' : 'Out of Stock';
            }
          }

          // Update add to cart button
          if (elements.addToCart) {
            elements.addToCart.classList.toggle('disabled', !isAvailable);
            elements.addToCart.toggleAttribute('disabled', !isAvailable);
          }

          // Update product image
          if (elements.productImage && variantImage) {
            elements.productImage.src = variantImage;
          }
        });
      });
    });
  }

  // Track current product for recently viewed
  function trackProduct() {
    const productPath = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (!productPath) return;

    const productHandle = document.querySelector('meta[name="product-handle"]')?.getAttribute('content') || productPath[1];
    if (productHandle) {
      addProduct(productHandle);
      cacheSwatchDataForCurrentProduct(productHandle);
    }
  }

  // Initialize main product slider for recently viewed
  function initializeRecentlyViewedSlider() {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      const slider = jQuery('#recently-viewed-products');

      // Destroy existing slider if initialized
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }

      // Initialize new slider
      slider.slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  }

  // Initialize color swatch sliders for recently viewed
  function initializeRecentlyViewedColorSliders(sectionId) {
    document.querySelectorAll(`#recently-viewed-${sectionId} .color-navigation`).forEach(colorNav => {
      // Destroy existing slider if initialized
      if (colorNav.classList.contains('slick-initialized')) {
        $(colorNav).slick('unslick');
      }

      const colorSwatches = colorNav.querySelectorAll('.scolor-box');

      // Only initialize slider if more than 4 colors
      if (colorSwatches.length > 4) {
        $(colorNav).slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev">‹</button>',
          nextArrow: '<button type="button" class="slick-next">›</button>',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 4,
              }
            }
          ]
        });
      }
    });
  }

  // Public API for recently viewed functionality
  return {
    trackProduct: trackProduct,
    loadProducts: loadProducts
  };
}

// Initialize recently viewed functionality
const recentlyViewed = initRecentlyViewed();

// Product variant selection functionality
function initProductVariants() {
  const productForm = document.getElementById('product-form');
  if (!productForm) return;

  const variantIdInput = document.getElementById('variant-id');
  const priceElement = document.querySelector('.pcurrent');
  const compareAtPriceElement = document.querySelector('.poriginal');
  const productSlider = document.querySelector('.pslider');
  const productNavigation = document.querySelector('.pnavigation');
  const skuElement = document.querySelector('.sku-number');

  // Get product data from the page
  let productData = null;

  if (window.product) {
    productData = window.product;
  } else {
    const productHandle = window.location.pathname.split('/').pop();
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(data => {
        productData = data;
        setupVariantListeners();
      })
      .catch(error => console.error('Error fetching product data:', error));
    return;
  }

  setupVariantListeners();

  // ---- helpers -------------------------------------------------------

  // The "control" for an option is either a <select> or the hidden <input>
  // that swatch/button groups write into. Individual <button> elements are
  // NOT controls themselves.
  function getOptionControls() {
    return Array.from(productForm.querySelectorAll('.pinfo [data-option-position]')).filter(function (el) {
      return el.tagName === 'SELECT' || (el.tagName === 'INPUT' && el.type === 'hidden');
    });
  }

  function getOptionNameFromControl(control) {
    const match = control.name.match(/options\[(.+)\]/);
    return match ? match[1] : null;
  }

  function getSelectedOptions() {
    const selected = {};
    getOptionControls().forEach(function (control) {
      const name = getOptionNameFromControl(control);
      if (name) selected[name] = control.value;
    });
    return selected;
  }

  function setupVariantListeners() {
    if (!productData) return;

    const optionControls = getOptionControls();

    optionControls.forEach(function (control) {
      control.removeEventListener('change', handleVariantChange);
      control.addEventListener('change', handleVariantChange);
    });

    // Colour swatches
    productForm.querySelectorAll('.swatch-group .color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectButtonValue(btn);
      });
    });

    // Button-style options (e.g. Gender)
    productForm.querySelectorAll('.option-buttons .option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectButtonValue(btn);
      });
    });

    // Static swatch legend rows also act as selectors, clicking a name/dot
    // picks the matching colour just like clicking the swatch itself
    productForm.querySelectorAll('.swatch-legend-item').forEach(function (li) {
      li.addEventListener('click', function () {
        const wrapper = li.closest('.pcolor');
        if (!wrapper) return;
        const matchingBtn = Array.from(wrapper.querySelectorAll('.color-swatch')).find(function (b) {
          return b.dataset.value === li.dataset.value;
        });
        if (matchingBtn) selectButtonValue(matchingBtn);
      });
    });

    updateAvailability();
    updateVariant();
  }

  function selectButtonValue(btn) {
    if (btn.disabled) return;

    const wrapper = btn.closest('.pcolor');
    if (!wrapper) return;

    const position = btn.dataset.optionPosition;
    const group = btn.closest('.swatch-group') || btn.closest('.option-buttons');
    const hiddenInput = wrapper.querySelector('input[type="hidden"][data-option-position="' + position + '"]');

    if (group) {
      group.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
    }
    btn.classList.add('active');
    wrapper.classList.remove('option-error');

    // Keep the static legend (if present) in sync with the selected swatch
    const legend = wrapper.querySelector('.swatch-legend');
    if (legend) {
      legend.querySelectorAll('.swatch-legend-item').forEach(function (li) {
        li.classList.toggle('active', li.dataset.value === btn.dataset.value);
      });
    }

    if (hiddenInput) {
      hiddenInput.value = btn.dataset.value;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function handleVariantChange(event) {
    const control = event.target;
    control.classList.remove('option-error');
    const wrapper = control.closest('.pcolor');
    if (wrapper) wrapper.classList.remove('option-error');

    updateAvailability();
    updateVariant();
  }

  // Greys out (rather than removing) values that can't produce an available
  // variant given the OTHER currently-selected options. Works across
  // selects, colour swatches, and option buttons alike.
  function updateAvailability() {
    if (!productData) return;
    const selected = getSelectedOptions();

    productData.options.forEach(function (option, index) {
      const position = index + 1;
      const optionName = option.name || option;
      const wrapper = productForm.querySelector('.pcolor[data-option-position="' + position + '"]');
      if (!wrapper) return;

      const others = Object.assign({}, selected);
      delete others[optionName];

      function isValueAvailable(value) {
        return productData.variants.some(function (variant) {
          if (variant['option' + position] !== value) return false;
          if (!variant.available) return false;
          return Object.keys(others).every(function (otherName) {
            if (!others[otherName]) return true;
            const otherIndex = productData.options.findIndex(function (o) {
              return (o.name || o) === otherName;
            });
            if (otherIndex === -1) return true;
            return variant['option' + (otherIndex + 1)] === others[otherName];
          });
        });
      }

      wrapper.querySelectorAll('select[data-option-position="' + position + '"] option[value]:not([value=""])').forEach(function (opt) {
        opt.disabled = !isValueAvailable(opt.value);
      });

      wrapper.querySelectorAll(
        '.color-swatch[data-option-position="' + position + '"], .option-btn[data-option-position="' + position + '"]'
      ).forEach(function (btn) {
        btn.disabled = !isValueAvailable(btn.dataset.value);
      });

      wrapper.querySelectorAll('.swatch-legend-item').forEach(function (li) {
        li.classList.toggle('unavailable', !isValueAvailable(li.dataset.value));
      });
    });
  }

  function updateVariant() {
    if (!productData) return;
    const selectedOptions = getSelectedOptions();
    const matchingVariant = findVariantByOptions(selectedOptions);
    if (matchingVariant) {
      updateProductDisplay(matchingVariant);
    }
  }

  function findVariantByOptions(selectedOptions) {
    return productData.variants.find(function (variant) {
      return productData.options.every(function (option, index) {
        const optionName = option.name || option;
        const variantOptionValue = variant['option' + (index + 1)];
        return selectedOptions[optionName] === variantOptionValue;
      });
    });
  }

  function updateProductDisplay(variant) {
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    if (priceElement) {
      priceElement.textContent = formatMoney(variant.price);
    }

    if (compareAtPriceElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareAtPriceElement.textContent = formatMoney(variant.compare_at_price);
        compareAtPriceElement.style.display = 'inline';
      } else {
        compareAtPriceElement.style.display = 'none';
      }
    }

    if (skuElement && variant.sku) {
      skuElement.textContent = `SKU: ${variant.sku}`;
    }

    if (variant.featured_image && productSlider && typeof jQuery !== 'undefined') {
      updateProductImages(variant.featured_image.src);
    }

    const addToCartButton = productForm.querySelector('button[type="submit"]');
    if (addToCartButton) {
      if (variant.available) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Add To Cart';
      } else {
        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Sold Out';
      }
    }
  }

  function updateProductImages(variantImageSrc) {
    const variantImageBase = variantImageSrc.split('/').pop().split('?')[0].replace(/_\d+x\d+/, '').split('.')[0];

    // Search using Slick's own logical slide markers where available, since
    // Slick clones slides for infinite scrolling and raw DOM order doesn't
    // reliably correspond to logical slide index once that's happened.
    // Match on EXACT base filename only — fuzzy substring matching caused
    // false positives between similarly named variant images (e.g.
    // "Black_police_folding_cap" vs "police_folding_cap_side"), which made
    // the code jump to a wrong slide instead of swapping the image.
    const indexedSlides = document.querySelectorAll('.pslider [data-slick-index]');
    let targetSlideIndex = -1;

    (indexedSlides.length ? indexedSlides : document.querySelectorAll('.pslider .pbox')).forEach((slideEl) => {
      // Skip Slick's clones — they carry negative/duplicate indexes that
      // must never be passed to slickGoTo.
      if (slideEl.classList && slideEl.classList.contains('slick-cloned')) return;
      const idx = slideEl.dataset ? parseInt(slideEl.dataset.slickIndex, 10) : NaN;
      if (!isNaN(idx) && idx < 0) return;

      const img = slideEl.querySelector('img') || (slideEl.tagName === 'IMG' ? slideEl : null);
      if (!img) return;
      const slideImageBase = img.src.split('/').pop().split('?')[0].replace(/_\d+x\d+/, '').split('.')[0];
      if (slideImageBase === variantImageBase) {
        targetSlideIndex = !isNaN(idx) ? idx : 0;
      }
    });

    // The gallery only ever contains the default variant's own photos
    // (limited to 6 media items in the Liquid), so most colour swaps will
    // never find a matching slide. When that happens, swap logical slide 0
    // (every physical copy of it, including Slick's clones) to the selected
    // variant's photo instead of silently staying on whatever was showing.
    if (targetSlideIndex === -1) {
      const slideZeroImgs = document.querySelectorAll('.pslider [data-slick-index="0"] img');
      if (slideZeroImgs.length) {
        slideZeroImgs.forEach((img) => { img.src = variantImageSrc; });
      } else {
        // Slick hasn't tagged slides yet (very first load) — plain fallback
        const firstImg = document.querySelector('.pslider .pbox img');
        if (firstImg) firstImg.src = variantImageSrc;
      }

      const navZeroImgs = document.querySelectorAll('.pnavigation [data-slick-index="0"] img');
      if (navZeroImgs.length) {
        navZeroImgs.forEach((img) => { img.src = variantImageSrc; });
      } else {
        const firstNavImg = document.querySelector('.pnavigation .pnav-wrap img');
        if (firstNavImg) firstNavImg.src = variantImageSrc;
      }

      targetSlideIndex = 0;
    }

    if (typeof jQuery !== 'undefined' && jQuery('.pslider').length > 0) {
      const $slider = jQuery('.pslider');

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          draggable: false,
          fade: true,
          centerPadding: '0px',
          asNavFor: '.pnavigation'
        });
      }

      setTimeout(() => {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickGoTo', targetSlideIndex, false);

          const $nav = jQuery('.pnavigation');
          if ($nav.length > 0 && $nav.hasClass('slick-initialized')) {
            $nav.slick('slickGoTo', targetSlideIndex, false);
          }
        }
      }, 100);
    }
  }

  function formatMoney(cents) {
    const amount = cents / 100;
    const symbol = (window.__CURRENCY__ && window.__CURRENCY__.symbol) || '£';
    return `${symbol}${amount.toFixed(2)}`;
  }
}



// Unified UI bindings and plugin initializations
function initUIBindings() {
  var $ = jQuery;

  // Product tab accordions — keep at least one open per group
  $(".tabbing-counter, .tabbing-details, .product-left .ptabbing, .product-right .ptabbing").each(function(){
    var $group = $(this);
    var $tabs = $group.find('.paccordian');

$tabs.off('click.paccordion').on('click.paccordion', function(){
  var $this = $(this);
  var content = $this.nextAll('.ptab-details, .ptab-desc').first();
  var isActive = $this.hasClass('active');

  if (isActive) {
    // Already open — close it
    $this.removeClass('active');
    content.slideUp();
    return;
  }

  // Close other panels in this group and open the clicked one
  $group.find('.ptab-details, .ptab-desc').not(content).slideUp();
  $tabs.not(this).removeClass('active');
  $this.addClass('active');
  content.slideDown();
});

    // Ensure at least one tab open on init for this group
    if ($tabs.filter('.active').length === 0 && $tabs.length > 0) {
      var $first = $tabs.first().addClass('active');
      $first.nextAll('.ptab-details, .ptab-desc').first().show();
      $tabs.not($first).each(function(){
        $(this).nextAll('.ptab-details, .ptab-desc').first().hide();
      });
    }
  });

  // Site logo slider
  if ($.fn.slick) {
    var $logoWrap = $('.site-logo-wrap');
    if ($logoWrap.length && !$logoWrap.hasClass('slick-initialized')) {
      $logoWrap.slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 3 } },
          { breakpoint: 480, settings: { slidesToShow: 2 } }
        ]
      });
    }
  }

  // Zoom on product image — hover devices (desktop) only. jquery.zoom
  // also intercepts touchstart/touchmove and prevents their default,
  // which on phones blocked page scrolling from the product image and
  // made the page "stick" while the zoomed image panned instead.
  var canHoverZoom = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if ($.fn.zoom && canHoverZoom) {
    var $pbox = $('.pbox-wrap');
    if ($pbox.length) {
      $pbox.zoom({
        url: $('.pbox-wrap img').attr('data-zoom-image'),
        on: 'mouseover',
        magnify: 1.5,
        touch: false
      });
    }
  }

  // Quantity buttons
  $(".plus").off('click.qty').on("click.qty", function(){
    var $input = $("#quantity");
    var value = parseInt($input.val(), 10) || 0;
    $input.val(value + 1);
  });
  $(".minus").off('click.qty').on("click.qty", function(){
    var $input = $("#quantity");
    var value = parseInt($input.val(), 10) || 0;
    var min = parseInt($input.attr("min"), 10) || 0;
    if (value > min) { $input.val(value - 1); }
  });

  // Teams sliders
  if ($.fn.slick) {
    var $teamsWrap = $('.teams-wrap');
    if ($teamsWrap.length && !$teamsWrap.hasClass('slick-initialized')) {
      $teamsWrap.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        draggable: false,
        infinite: true,
        adaptiveHeight: true, 
        asNavFor: '.team-profile'
      });
      // adaptiveHeight measures before images load; refresh once loaded
      jQuery(window).on('load.teamsheight orientationchange.teamsheight', function(){
        if ($teamsWrap.hasClass('slick-initialized')) {
          $teamsWrap.slick('setPosition');
        }
      });
    }
    var $teamProfile = $('.team-profile');
if ($teamProfile.length && !$teamProfile.hasClass('slick-initialized')) {
  $teamProfile.slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.teams-wrap',
    dots: false,
    arrows: true,
    centerMode: false,
    infinite: true,
    draggable: false,
    focusOnSelect: true,
    variableWidth: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true } },
      { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: true } },
      { breakpoint: 641, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true } },
      { breakpoint: 481, settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true } }
    ]
  });
}
  }

  // Product sliders — initialised per gallery. The product template
  // renders the gallery twice (desktop column + mobile .mbp-thumb copy);
  // the old global init cross-linked every slider to every thumbnail
  // strip via asNavFor, which broke thumbnail taps and swiping on
  // mobile. Each gallery is now linked only to its own thumbnails.
  if ($.fn.slick) {
    $('.product-thumb').each(function(){
      var $thumb = $(this);
      var $slider = $thumb.find('.pslider');
      var $nav = $thumb.find('.pnavigation');
      if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          draggable: false,
          fade: true,
          centerPadding: '0px',
          asNavFor: $nav.length ? $nav : null
        });
      }
      if ($nav.length && !$nav.hasClass('slick-initialized')) {
        $nav.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: $slider.length ? $slider : null,
          centerPadding: '0px',
          dots: false,
          draggable: true,
          swipeToSlide: true,
          infinite: false,
          centerMode: false,
          focusOnSelect: true,
          variableWidth: false,
          responsive: [
            { breakpoint: 768, settings: { slidesToShow: 4 } },
            { breakpoint: 480, settings: { slidesToShow: 3 } }
          ]
        });
      }
    });
  }

  // Certification accordion
  $(".certi-accordian-breif").first().addClass("active").next(".certi-accodian-detail").show();
  $(".certi-accordian-breif").off('click.certi').on("click.certi", function() {
    var $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active").next(".certi-accodian-detail").slideUp(300);
    } else {
      $(".certi-accordian-breif.active").removeClass("active").next(".certi-accodian-detail").slideUp(300);
      $this.addClass("active").next(".certi-accodian-detail").slideDown(300);
    }
  });

  // FAQ accordion
  $(".faq-question").first().addClass("active").next(".faq-answer").show();
  $(".faq-question").off('click.faq').on("click.faq", function() {
    var $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active").next(".faq-answer").slideUp(300);
    } else {
      $(".faq-question.active").removeClass("active").next(".faq-answer").slideUp(300);
      $this.addClass("active").next(".faq-answer").slideDown(300);
    }
  });

  // Generic product slider
  if ($.fn.slick) {
    var $productSlider = $('.product-slider');
    if ($productSlider.length && !$productSlider.hasClass('slick-initialized')) {
      $productSlider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3 } },
          { breakpoint: 767, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      });
    }
  }

  // Compare price switch
  var $switch = $('#compare-switch');
  function togglePriceCompare(on){
    $('.price-compare').toggle(!!on);
    $('.compare-btn').toggle(!!on);
  }
  if ($switch.length) { togglePriceCompare($switch.is(':checked')); }
  $(document).off('change.compare','#compare-switch').on('change.compare','#compare-switch', function(){ togglePriceCompare(this.checked); });

  // Card quick-add: a swatch click counts as choosing the variant
  $(document).off('click.needsel', '.color-swatch').on('click.needsel', '.color-swatch', function(){
    var card = this.closest('.product-card, .pbox');
    if (!card) return;
    var form = card.querySelector('form[action*="/cart/add"]');
    if (form && form.dataset.needsSelection === 'true') { form.dataset.needsSelection = 'chosen'; }
    var nav = card.querySelector('.color-navigation');
    if (nav) { nav.classList.remove('option-error'); }
  });

  // Product filter sidebar toggle: drawer on mobile, collapse/expand on desktop
  $('.product-filter').off('click.pfilter').on('click.pfilter', function(){
    if (window.matchMedia('(max-width: 767px)').matches) {
      $('.product-sidebar').addClass('open');
    } else {
      $('.product-body').toggleClass('filters-collapsed');
    }
  });
  $(document).off('click.pfilter','.product-sidebar .close').on('click.pfilter','.product-sidebar .close', function(e){ e.preventDefault(); $('.product-sidebar').removeClass('open'); });
}

// Back to Top Button Functionality
function initBackToTop() {
  var $ = jQuery;
  function toggleBackToTop() {
    var scrollTop = $(window).scrollTop();
    var $backToTopBtn = $('.back-to-top, .backtotop, [class*="back-top"], [class*="scroll-top"]');
    if (scrollTop > 300) { $backToTopBtn.fadeIn(); } else { $backToTopBtn.fadeOut(); }
  }
  $(window).off('scroll.backtotop').on('scroll.backtotop', cgRafThrottle(toggleBackToTop)); // audit fix 14
  toggleBackToTop();
}


jQuery(document).ready(function() {
  jQuery('#df_manual_book').on('wheel mousewheel DOMMouseScroll', function(e) {
    e.preventDefault(); // stop zoom or scroll
    e.stopPropagation(); // prevent it from affecting parent scroll
    return false; // ensure no default scroll action
  });


  // Open popup + disable scroll
  jQuery('.newsletter .common-btn').on('click', function(e){
      e.preventDefault();
      jQuery('#mc_embed_signup').fadeIn(500);
      jQuery('body').css('overflow', 'hidden'); // Disable scroll
  });

  // Close popup + enable scroll
  jQuery(document).on('click', '.mc-close-btn', function(e){
      e.preventDefault();
      jQuery('#mc_embed_signup').fadeOut(500);
      jQuery('body').css('overflow', 'auto'); // Enable scroll
  });


  
});

// Safety: ensure UI bindings initialize even if other inits error out
jQuery(function(){
  try { if (typeof initUIBindings === 'function') initUIBindings(); } catch(e) { console.error('initUIBindings fallback failed', e); }
});

// Global Compare UI: floating button + modal rendering
(function($){
  const LOCAL_KEY = 'shopify_compare_products';
  const MAX_COMPARE = 4;

  function getStored(){
    try {
      const raw = localStorage.getItem(LOCAL_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch(e){
      return [];
    }
  }
  function setStored(arr){
    try { localStorage.setItem(LOCAL_KEY, JSON.stringify(arr)); } catch(e) {}
  }
  function clearStored(){ try { localStorage.removeItem(LOCAL_KEY); } catch(e) {}
  }

  async function fetchProduct(handle){
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Product fetch failed');
      return await res.json();
    } catch(e){
      console.warn('Compare fetch error', e);
      return null;
    }
  }

  function openModal(){
    const $modal = $('#compare-modal');
    if (!$modal.length) return;
    $modal.addClass('show').attr('aria-hidden','false');
  }
  function closeModal(){
    const $modal = $('#compare-modal');
    if (!$modal.length) return;
    $modal.removeClass('show').attr('aria-hidden','true');
  }

  function updateCounts(){
    const count = getStored().length;
    $('#compare-count').text(count);
    $('#compare-button-count').text(count);
  }

  function escapeHtml(str){
    const div = document.createElement('div');
    div.textContent = String(str || '');
    return div.innerHTML;
  }
  // Fallback: simple renderer for compare modal when page-specific renderer isn't available
  function formatMoney(cents){
    try {
      const num = Number(cents);
      if (!isFinite(num)) return '';
      return (num / 100).toFixed(2);
    } catch(_) { return ''; }
  }
  function removeFromCompare(handle){
    const arr = getStored();
    const filtered = arr.filter(item => {
      if (typeof item === 'string') return item !== handle;
      return item && item.handle !== handle;
    });
    setStored(filtered);
    return filtered;
  }
  async function renderSimple(){
    const container = document.getElementById('compare-table-wrap');
    if (!container) return;
    const raw = getStored();

    // Normalize to product objects – fetch if stored as handles
    const products = [];
    for (const item of raw){
      if (!item) continue;
      if (typeof item === 'string') {
        const p = await fetchProduct(item);
        if (p) products.push(p);
      } else if (item && typeof item === 'object') {
        products.push(item);
      }
    }

    // Update counts
    $('#compare-count').text(products.length);
    $('#compare-button-count').text(products.length);

    if (!products.length){
      container.innerHTML = '<p>No products selected for comparison. Click Compare on product cards to add.</p>';
      return;
    }

    const currencySymbol = (window.__CURRENCY__ && window.__CURRENCY__.symbol) || '$';

    // Build table markup similar to listing-page renderer
    let html = '<table id="compare-table">';
    html += '<thead><tr><th></th>';
    products.forEach(p => {
      const img = (p.images && p.images[0]) || (p.image || '');
      html += `<th>
        <div class="compare-product-header">
          ${img ? `<img src="${img}" alt="${escapeHtml(p.title || '')}" />` : ''}
          <div>
            <strong>${escapeHtml(p.title || '')}</strong><br/>
            <small>${escapeHtml(p.vendor || '')}</small>
          </div>
        </div>
        <div style="margin-top:8px;">
          <button class="compare-remove" data-handle="${p.handle}">Remove</button>
        </div>
      </th>`;
    });
    html += '</tr></thead>';

    const baseAttrs = [
      { key: 'title', label: 'Product' },
      { key: 'price', label: 'Price' },
      { key: 'vendor', label: 'Vendor' },
      { key: 'type', label: 'Type' },
      { key: 'tags', label: 'Tags' },
      { key: 'description', label: 'Description' },
      { key: 'add_to_cart', label: 'Add to Cart' }
    ];

    html += '<tbody>';
    baseAttrs.forEach(attr => {
      html += `<tr data-attr="${attr.key}"><th>${escapeHtml(attr.label)}</th>`;
      products.forEach(p => {
        let cell = '';
        switch(attr.key){
          case 'title':
            cell = `<a href="/products/${encodeURIComponent(p.handle)}">${escapeHtml(p.title || '')}</a>`;
            break;
          case 'price': {
            const v0 = (p.variants && p.variants[0]) ? p.variants[0] : null;
            const cents = v0 && v0.price ? v0.price : (p.price_min || p.price || null);
            const val = cents != null ? `${currencySymbol}${formatMoney(cents)}` : '';
            cell = val;
            break;
          }
          case 'vendor':
            cell = escapeHtml(p.vendor || '');
            break;
          case 'type':
            cell = escapeHtml(p.type || p.product_type || '');
            break;
          case 'tags':
            if (Array.isArray(p.tags) && p.tags.length) {
              const displayTags = p.tags.map(t => escapeHtml(t)).join(', ');
              cell = `<div class="compare-tags">${displayTags}</div>`;
            } else {
              cell = '';
            }
            break;
          case 'description':
            cell = `<div style="max-width:300px;overflow:auto">${escapeHtml(String(p.description || '').slice(0,300))}</div>`;
            break;
          case 'add_to_cart': {
            const vid = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : '';
            cell = vid ? `<button class="add-to-cart-compare common-btn" data-variant-id="${vid}" data-handle="${escapeHtml(p.handle)}">Add to Cart</button>` : '';
            break;
          }
          default:
            cell = '';
        }
        html += `<td>${cell}</td>`;
      });
      html += '</tr>';
    });
    html += '</tbody></table>';

    container.innerHTML = html;

    // Bind remove buttons
    container.querySelectorAll('.compare-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const h = btn.getAttribute('data-handle');
        removeFromCompare(h);
        renderSimple();
      });
    });

    // Bind add-to-cart buttons
    container.querySelectorAll('.add-to-cart-compare').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(id), quantity: 1 })
          });
          if (res.ok) {
            btn.textContent = 'Added';
            btn.classList.add('added');
          } else {
            btn.disabled = false;
          }
        } catch(_) {
          btn.disabled = false;
        }
      });
    });
  }

  function bindGlobal(){
    // Floating button opens modal and renders
    $(document).off('click.compare','#compare-floating-btn').on('click.compare','#compare-floating-btn', function(e){
      e.preventDefault();
      if (typeof window.openCompareModal === 'function' && typeof window.renderCompare === 'function') {
        try { window.openCompareModal(); window.renderCompare(); }
        catch(_){ openModal(); renderSimple(); }
      } else {
        // Fallback: just open modal; content may be managed by page-specific logic
        openModal();
        // Use simple renderer when detailed renderer is unavailable
        renderSimple();
      }
    });

    // Modal close buttons
    $(document).off('click.compare','[data-close]').on('click.compare','[data-close]', function(e){
      e.preventDefault();
      if (typeof window.closeCompareModal === 'function') {
        try { window.closeCompareModal(); }
        catch(_){ closeModal(); }
      } else {
        closeModal();
      }
    });

    // ESC to close
    $(document).off('keydown.compare').on('keydown.compare', function(e){ if (e.key === 'Escape') closeModal(); });

    // Update counts on load and when storage changes
    updateCounts();
    $(window).on('storage', function(e){
      try {
        if (e.originalEvent && e.originalEvent.key === LOCAL_KEY) updateCounts();
      } catch(_){ updateCounts(); }
    });
  }

  $(function(){ bindGlobal(); });
})(jQuery);
// ═══ Audit fix 3: touch support for the desktop nav dropdowns ═══
// Above 767px the nav submenus / Products mega-menu open on :hover only,
// which touch devices (iPads, touch laptops) don't reliably have. On a
// touch device, the FIRST tap on a menu item that owns a dropdown opens it
// (via the .tap-open class in media.css); a second tap follows the link.
// Tapping anywhere else closes the open dropdown.
(function($){
  var touchOnly = window.matchMedia ? window.matchMedia('(hover: none)') : { matches: false };
  var mobileDrawer = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };

  $(document).on('click.cgtouchnav', '.site-menu .menu > .menu-item > a', function(e){
    if (!touchOnly.matches || mobileDrawer.matches) return; // mouse device, or the drawer handles it
    var $item = $(this).closest('.menu-item');
    if (!$item.children('ul.submenu, ul.mega-menu').length) return; // plain link
    if (!$item.hasClass('tap-open')) {
      e.preventDefault();
      $('.site-menu .menu-item.tap-open').removeClass('tap-open');
      $item.addClass('tap-open');
    }
    // second tap: no preventDefault — the link navigates normally
  });

  $(document).on('click.cgtouchnavclose', function(e){
    if (!$(e.target).closest('.site-menu .menu-item').length) {
      $('.site-menu .menu-item.tap-open').removeClass('tap-open');
    }
  });
})(jQuery);